import React, { useEffect } from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import moment from 'moment';
import { Tooltip, Typography } from '@mui/material';
import { IN_TEXT, OUT_TEXT } from '../../../constants';

const TimeLineItem = (props) => {
  const { rawTimeData, selectedDate, finalTimelogIndex } = props;

  useEffect(() => {}, []);

  return (
    <Timeline position="alternate">
      {rawTimeData
        .filter(
          (data) =>
            moment(data.logDate).format('DD/MM/YYYY') ===
            moment(selectedDate).format('DD/MM/YYYY'),
        )
        .map((data, index) =>
          props.employeeId || (!props.employeeId && !data.isArchived) ? (
            <TimelineItem key={data.id}>
              <TimelineSeparator>
                {data.direction.toLowerCase() === 'in' ? (
                  <Tooltip
                    PopperProps={{ disablePortal: true }}
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        {IN_TEXT}
                      </Typography>
                    }
                  >
                    <DirectionsWalkIcon
                      fontSize="medium"
                      sx={
                        props.employeeId
                          ? data.isArchived
                            ? { color: 'grey' }
                            : {
                                color: 'green',
                                '&:hover': {
                                  cursor: 'pointer',
                                },
                              }
                          : data.isArchived
                          ? { display: 'none' }
                          : { color: 'green' }
                      }
                      onClick={
                        props.employeeId
                          ? () => {
                              props.TimeLineItemThings(
                                data.id,
                                data.isArchived,
                              );
                            }
                          : null
                      }
                    />
                  </Tooltip>
                ) : (
                  <Tooltip
                    PopperProps={{ disablePortal: true }}
                    title={
                      <Typography sx={{ fontSize: '0.8rem' }}>
                        {OUT_TEXT}
                      </Typography>
                    }
                  >
                    <DirectionsWalkIcon
                      fontSize="medium"
                      sx={
                        props.employeeId
                          ? data.isArchived
                            ? { color: 'grey' }
                            : {
                                color: 'red',
                                transform: 'scaleX(-1)',
                                '&:hover': {
                                  cursor: 'pointer',
                                },
                              }
                          : data.isArchived
                          ? { display: 'none' }
                          : { color: 'red', transform: 'scaleX(-1)' }
                      }
                      onClick={
                        props.employeeId
                          ? () => {
                              props.TimeLineItemThings(
                                data.id,
                                data.isArchived,
                              );
                            }
                          : null
                      }
                    />
                  </Tooltip>
                )}

                {index === rawTimeData.length - 1 ||
                index === finalTimelogIndex ? null : (
                  <TimelineConnector />
                )}
              </TimelineSeparator>
              <TimelineContent>
                <Typography
                  sx={
                    props.employeeId
                      ? data.isArchived
                        ? { filter: 'blur(1px)' }
                        : {}
                      : data.isArchived
                      ? { display: 'none' }
                      : {}
                  }
                >
                  {data.logTime.slice(0, 8)}
                </Typography>
                <Typography
                  sx={
                    props.employeeId
                      ? data.isArchived
                        ? { filter: 'blur(1px)' }
                        : {}
                      : data.isArchived
                      ? { display: 'none' }
                      : {}
                  }
                >
                  ({data.deviceName})
                </Typography>
              </TimelineContent>
            </TimelineItem>
          ) : (
            ''
          ),
        )}
    </Timeline>
  );
};

export default TimeLineItem;
